import React, { useState } from 'react';
import { connect } from 'react-redux';
import Link from 'redux-first-router-link';
import ZohoForm from '../../hocs/ZohoForm/ZohoForm';
import { translate, prefix } from '../../utils/locale';
import { urlify } from '../../utils/string';
import s from './Footer.scss';
import './Photoswipe.scss';

const Footer = ({ properties, setup, footer, newsletter, navigation }) => {
	if (properties.siteInitiated === false || properties.siteClosed === true) return null;
	const [accordianIndex, toggleAccordianMenus] = useState('#contact-toggle');

	const accordianHandler = (e) => {
		const href = e.currentTarget.dataset.href;
		if (accordianIndex === href) {
			toggleAccordianMenus(null);
		} else {
			toggleAccordianMenus(href);
		}
	};

	return (
		<footer className={s.footer}>
			<div className={s.footer_newsletter}>
				<ZohoForm setup={setup} htmlBlob={newsletter?.newsletterZohoForm} multistep />
			</div>
			<nav className={s.footer_items}>
				{
					navigation?.header && [...navigation.header, ...(navigation?.support ? navigation.support : [])].map((level1) => {
						const level1Uri = level1.uri ? prefix(setup, translate(setup, level1, 'uri')) : null;
						const level1Title = translate(setup, level1, 'title');
						const level1Key = level1.uri || urlify(level1Title);

						return (
							<div className={s.footer_item} key={level1Key}>
								<div className={s.footer_item_top}>
									{
										level1Uri ? (
											<Link className={s.footer_item_top_link} to={level1Uri}>
												{ level1Title }
											</Link>
										) : (
											<span className={s.footer_item_top_link}>{ level1Title }</span>
										)
									}
									{
										level1?.subPages && (
											<button type="button" className={s.footer_item_top_toggle} aria-expanded={accordianIndex === level1Key} onClick={accordianHandler} data-href={level1Key} aria-label={`Toggle ${level1Title} links`}>
												<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
													{ accordianIndex !== level1Key && <line x1="10.0234" y1="2.08149e-08" x2="10.0234" y2="20" stroke="black" /> }
													<line x1="20" y1="10.5" x2="-4.37114e-08" y2="10.5" stroke="black" />
												</svg>
											</button>
										)
									}
								</div>
								{
									accordianIndex === level1Key && level1?.subPages && (
										<div className={s.footer_item_subLinks}>
											{
												level1.subPages.map((level2) => (
													<Link className={s.footer_item_subLink} to={prefix(setup, translate(setup, level2, 'uri'))} key={translate(setup, level2, 'uri')}>{ translate(setup, level2, 'title') }</Link>
												))
											}
										</div>
									)
								}
							</div>
						);
					})
				}
				<div className={s.footer_socialLinks}>
					{
						footer.socialMediaIcons && footer.socialMediaIcons.map((item) => {
							if (item.link.indexOf(/(http|mailto|tel)/) === -1) {
								return <a className={s.footer_socialLink} href={item.link} key={urlify(item.icon.url)} target="_blank" rel="noopener noreferrer nofollow"><img className={s.footer_socialLink_icon} src={item.icon.url} alt={item.icon.alt} /></a>;
							}
							return <Link className={s.footer_socialLink} to={prefix(setup, item.link)} key={urlify(item.icon.url)} rel="nofollow"><img className={s.footer_socialLink_icon} src={item.icon.url} alt={item.icon.alt} /></Link>;
						})
					}
				</div>
			</nav>
		</footer>
	);
};

const mapState = ({ environment }) => {
	const { properties, setup, footer, header, newsletter, navigation } = environment;
	return { properties, setup, footer, header, newsletter, navigation };
};

export default connect(mapState)(Footer);
